import React, { useRef, useState, useEffect } from "react"
import "./book-page.scss"
import { Link } from "gatsby"

import { OutboundLink } from "gatsby-plugin-google-gtag"
import bookRR from "../../components/books/asset/reflecting.png"

import { sawalSamayKe } from "../../data/books"
import getCurrencySymbol from "../../data/countryCurrencySymbols"
import AmazonIcon from "./asset/Amazon.png"
import SnapdealIcon from "./asset/Snapdeal.png"
import FlipkartIcon from "./asset/Flipkart.png"
import Books from "../books/Books"

const defaultCountry = "India"

const BookPage = ({ book }) => {
  const [currentImage, setCurrentImage] = useState(null)
  const [currentCountry, setCurrentCountry] = useState(defaultCountry)

  const {
    isEbook,
    title,
    bookDescription,
    aboutAuthor,
    images: bookImages,
    meta,
    buyLinks,
    contributors,
    pricing,
  } = book
  const defaultImage = bookImages[0].fullSize
  const { binding, languages } = meta
  const currencySymbol = getCurrencySymbol(defaultCountry)

  useEffect(() => {
    setCurrentImage(defaultImage)
    setCurrentCountry(defaultCountry)
  }, [book])

  const getImageFromPlatformName = name => {
    switch (name) {
      case "Amazon":
        return AmazonIcon
      case "Flipkart":
        return FlipkartIcon
      case "Snapdeal":
        return SnapdealIcon
    }
  }

  const renderBookThumbNails = imagesList => {
    return imagesList.map(bookImage => {
      const { thumbnail, fullSize } = bookImage
      return (
        <div className="thumbnail" onClick={() => setCurrentImage(fullSize)}>
          <img src={thumbnail} />
        </div>
      )
    })
  }
  const renderBookPeople = contributorsData => {
    let howManyPeople = contributorsData.length
    if (howManyPeople) {
      const isMoreThanOneContributor = howManyPeople > 1
      const contributorsList = contributorsData.map(contributor => {
        const { name, contributedAs } = contributor
        return (
          <div className="contributor">
            <span className="name">{name}</span>
            {isMoreThanOneContributor ? (
              <span className="contribution">({contributedAs})</span>
            ) : null}
          </div>
        )
      })
      return <h2 className="book-contributors">by {[...contributorsList]}</h2>
    }
  }
  const renderPricing = pricingData => {
    const {
      mrp,
      price,
      discount: { percent: discountPercent, amount: discountAmount },
    } = pricingData[currentCountry]
    return (
      <div className="book-pricing">
        <div className="cost pricings">
          {currencySymbol}
          {price}
        </div>
        <div className="mrp pricings">
          {currencySymbol}
          {mrp}
        </div>
        <div className="discount pricings">{discountPercent}% off</div>
      </div>
    )
  }
  const renderAvailableBuyLinks = buyLinksData => {
    const availableBuyLinksData = buyLinksData.filter(
      buyLinkData => buyLinkData.country === currentCountry
    )
    return availableBuyLinksData.map(availableBuyLinkData => {
      return availableBuyLinkData.platforms.map(availablePlatform => {
        const { name, link } = availablePlatform
        return (
          <Link to={link} target="_blank" className={`buy-platform ${name}`}>
            <img src={getImageFromPlatformName(name)} />
          </Link>
        )
      })
    })
  }
  const renderMetaDetails = metaData => {
    return Object.keys(metaData).map((key, index) => {
      const metaValue = metaData[key]
      return (
        <div className="one-info">
          <div className="meta">{key}:</div>
          <div className="meta-value">
            {Array.isArray(metaValue) ? metaValue.join(" | ") : metaValue}
          </div>
        </div>
      )
    })
  }

  return (
    <section className="section book-page-section">
      <div className="book-wrapper">
        <div className="book-images">
          <div className="image-selector">
            {renderBookThumbNails(bookImages)}
          </div>
          <div className="big-image">
            <img src={currentImage} />
          </div>
        </div>
        <div className="book-details">
          <h1 className="book-title">
            {title}
            <span className="book-title-meta">
              ({languages.join(" | ")}, {binding})
            </span>
          </h1>
          {renderBookPeople(contributors)}
          {renderPricing(pricing)}
          <div className="other-buy-options">
            {/* <div className="buy-from">buy from : </div> */}
            {renderAvailableBuyLinks(buyLinks)}
          </div>
          <div className="product-details-wrapper">
            <div className="product-details-title">Product details</div>
            <div className="details-grid">{renderMetaDetails(meta)}</div>
          </div>
          {bookDescription && (
            <div className="product-details-wrapper">
              <div className="product-details-title">About the Book</div>
              <div className="product-details-desc">{bookDescription}</div>
            </div>
          )}
          {aboutAuthor && (
            <div className="product-details-wrapper">
              <div className="product-details-title">About Author</div>
              <div className="product-details-desc">{aboutAuthor}</div>
            </div>
          )}
        </div>
      </div>
      <Books />
    </section>
  )
}

export default BookPage
